import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Manageduser } from '../../interfaces/manageduser';
import { Pendingapprovals } from '../../interfaces/pendingapprovals';
import { InviteUserPayload } from '../../interfaces/invite-user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private apiService: ApiService) {}

  getUsers(): Observable<any> {
    return this.apiService.get<any>(`/v1/users`);
  }
  deleteUser(UserID: number): Observable<Manageduser> {
    return this.apiService.delete<Manageduser>(`/v1/users/${UserID}`);
  }

  validateUser(UserID: number, approve: boolean): Observable<Pendingapprovals> {
    const approve_data = { approve };
    return this.apiService.post<Pendingapprovals>(`/v1/users/validate/${UserID}`, approve_data);
  }
  denyUser(UserID: number): Observable<Pendingapprovals> {
    const body = {};
    return this.apiService.post<Pendingapprovals>(`/v1/users/deny/${UserID}`, body);
  }
  approveUser(UserID: number): Observable<Pendingapprovals> {
    const body = {};
    return this.apiService.post<Pendingapprovals>(`/v1/users/approve/${UserID}`, body);
  }

  editUserRoleByUserId(userData: Manageduser): Observable<any> {
    const { userID, role } = userData;
    const reqBody = {
      Role: role,
    };
    return this.apiService.patch(`/v1/users/${userID}/role`, reqBody);
  }
  inviteUser(userData: InviteUserPayload): Observable<any> {
    return this.apiService.post(`/v1/organizations/invite`, userData);
  }
}
